export { default } from "./CommentIcon";
